/**
 * @generated SignedSource<<947d786981af1ebda5c9655c379de3df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contactsInlineFragment$data = {
  readonly id: string;
  readonly firstName: string | null;
  readonly lastName: string | null;
  readonly source: string;
  readonly email: string;
  readonly accountId: string;
  readonly createdAt: any | null;
  readonly createdBy: string | null;
  readonly contactTeamMembers: ReadonlyArray<{
    readonly id: string;
    readonly teamMember: {
      readonly id: string;
      readonly memberUserProfile: {
        readonly firstName: string;
        readonly lastName: string;
      };
    };
  }>;
  readonly unmindUserId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"contactSessionLimitsRemainingInlineFragment" | "contactHasActiveEventRequestInlineFragment">;
  readonly " $fragmentType": "contactsInlineFragment";
};
export type contactsInlineFragment$key = {
  readonly " $data"?: contactsInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"contactsInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "contactsInlineFragment"
};

(node as any).hash = "99c76fec3f6bf3c7d7c79c99d0d2200e";

export default node;
